function TagVisitLink() {
    "use strict";

    this.__type = 'TagVisitLink:www.veritracks.com';
    this.Id = -1;

    this.IsActive = true;
    this.Name = '';
    this.TagId = -1;
    this.VisitId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = TagVisitLink;
}